import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function campaignItemsHasErrored(bool) {
  return {
    type: 'CAMPAIGN_ITEMS_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function campaignItemsIsLoading(bool) {
  return {
    type: 'CAMPAIGN_ITEMS_IS_LOADING',
    isLoading: bool,
  };
}
export function campaignItemsFetchDataSuccess(items) {
  return {
    type: 'CAMPAIGN_ITEMS_FETCH_DATA_SUCCESS',
    items,
  };
}

export function campaignItemHasErrored(bool) {
  return {
    type: 'CAMPAIGN_ITEM_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function campaignItemIsLoading(bool) {
  return {
    type: 'CAMPAIGN_ITEM_IS_LOADING',
    isLoading: bool,
  };
}

export function campaignItemFetchDataSuccess(item) {
  return {
    type: 'CAMPAIGN_ITEM_FETCH_DATA_SUCCESS',
    item,
  };
}

export function newCampaignSaveSuccess(bool, campaign) {
  return {
    type: 'CAMPAIGN_SAVE_SUCCESS',
    isSavedSuccess: bool,
    campaign: campaign,
  };
}

export function newCampaignSaveErrored(bool, message) {
  return {
    type: 'CAMPAIGN_SAVE_ERRORED',
    isSaveErrored: bool,
    message: message,
  };
}

export function newCampaignIsSaving(bool) {
  return {
    type: 'CAMPAIGN_IS_SAVING',
    isSaving: bool,
  };
}

export function redirectToCampaignListPage(bool) {
  return {
    type: 'REDIRECT_TO_CAMPAIGN_LIST',
    doRedirectToCampaignListPage: bool,
  };
}

function buildQueryString(source, startDate, endDate, searchCriteria, status) {
  let queryString = '';
  if (source) queryString += '&source=' + source;
  queryString += '&startDate=' + startDate;
  queryString += '&endDate=' + endDate;
  if (searchCriteria) queryString += '&searchCriteria=' + searchCriteria;
  if (status) queryString += '&status=' + status;
  return queryString ? '?' + queryString.substring(1) : '';
}

export function campaignItemsFetchData(
  source,
  startDate,
  endDate,
  searchCriteria,
  status,
) {
  const queryString = buildQueryString(
    source,
    startDate,
    endDate,
    searchCriteria,
    status,
  );
  const url = queryString
    ? apiEndPoints.CAMPAIGN_LIST + queryString
    : apiEndPoints.CAMPAIGN_LIST;
  return async (dispatch) => {
    dispatch(campaignItemsIsLoading(true));
    try {
      const response = await adalApiFetch(fetch, url, {});
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      dispatch(campaignItemsIsLoading(false));
      const items = await response.json();
      dispatch(campaignItemsFetchDataSuccess(items));
    } catch (error) {
      dispatch(campaignItemsHasErrored(true));
      dispatch(campaignItemsIsLoading(false));
      // eslint-disable-next-line no-console
      console.error('Error fetching campaigns', error);
    }
  };
}

export function getCampaignData(id) {
  const url = apiEndPoints.CAMPAIGN_DETAILS.replace('campaignId', id);
  return async (dispatch) => {
    dispatch(campaignItemIsLoading(true));
    dispatch(redirectToCampaignListPage(false));
    try {
      const response = await adalApiFetch(fetch, url, {});
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const item = await response.json();
      dispatch(campaignItemFetchDataSuccess(item));
      dispatch(campaignItemIsLoading(false));
    } catch (error) {
      dispatch(campaignItemHasErrored(true));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}

export function addNewCampaignData(newCampaign) {
  const url = apiEndPoints.CAMPAIGN_ADD;
  return async (dispatch) => {
    dispatch(newCampaignIsSaving(true));
    try {
      const response = await adalApiFetch(fetch, url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(newCampaign),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      dispatch(newCampaignIsSaving(false));
      if (response.ok) {
        const campaign = await response.json();
        dispatch(newCampaignSaveSuccess(true, campaign));
        dispatch(redirectToCampaignListPage(true));
      } else {
        switch (response.status) {
          case 422: {
            const error = await response.json();
            const items = Object.values(error);
            const message = items.join('; ');
            dispatch(newCampaignSaveErrored(true, message));
            break;
          }
          default: {
            const error = await response.json();
            dispatch(newCampaignSaveErrored(true, error.message));
            break;
          }
        }
      }
    } catch (error) {
      dispatch(newCampaignIsSaving(false));
      dispatch(newCampaignSaveErrored(true, error.message || 'Unknown error'));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}

export function editCurrCampaignData(currCampaign) {
  const url = `${apiEndPoints.CAMPAIGN_ADD}/${currCampaign.id}`;
  return async (dispatch) => {
    dispatch(newCampaignIsSaving(true));
    try {
      const response = await adalApiFetch(fetch, url, {
        method: 'PUT',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(currCampaign),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      dispatch(newCampaignIsSaving(false));
      if (response.ok) {
        dispatch(redirectToCampaignListPage(true));
      } else {
        switch (response.status) {
          case 422: {
            const error = await response.json();
            const items = Object.values(error);
            const message = items.join('; ');
            dispatch(newCampaignSaveErrored(true, message));
            break;
          }
          default: {
            const error = await response.json();
            dispatch(newCampaignSaveErrored(true, error.message));
            break;
          }
        }
      }
    } catch (error) {
      dispatch(newCampaignIsSaving(false));
      dispatch(newCampaignSaveErrored(true, error.message || 'Unknown error'));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}
